// Tooltip Component

import React from 'react'
import ReactDom from 'react-dom'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class Tooltip extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      displayTooltip: false
    }

    this.hideTooltip = this._hideTooltip.bind(this)
    this.showTooltip = this._showTooltip.bind(this)

    this._references = {
      content: React.createRef(),
      tip: React.createRef()
    }
  }

  static get propTypes () {
    return {
      trigger: PropTypes.any,
      position: PropTypes.string,
      message: PropTypes.string,
      children: PropTypes.any
    }
  }

  static get defaultProps () {
    return {
      trigger: null,
      position: '',
      message: '',
      children: null
    }
  }

  componentDidMount () {
    const { trigger, position } = this.props
    this._initPosition(trigger, position)
  }

  componentDidUpdate (prevProps) {
    const { trigger, position } = this.props

    if (!prevProps.trigger && prevProps.trigger !== trigger) {
      this._initPosition(trigger, position)
    }
  }

  componentWillUnmount () {
    const { trigger } = this.props
    if (trigger) {
      const triggerEl = ReactDom.findDOMNode(trigger)
      triggerEl.removeEventListener('mouseover', this.showTooltip)
      triggerEl.removeEventListener('mouseleave', this.hideTooltip)
    }
  }

  _hideTooltip () {
    this.setState({ displayTooltip: false })
  }

  _showTooltip () {
    this.setState({ displayTooltip: true })
  }

  _initPosition (trigger, position) {
    if (trigger) {
      const triggerEl = ReactDom.findDOMNode(trigger)
      triggerEl.addEventListener('mouseover', this.showTooltip)
      triggerEl.addEventListener('mouseleave', this.hideTooltip)
    }

    if (trigger && this._references.content.current) {
      const {
        width: triggerWidth,
        height: triggerHeight,
        top: triggerTop
      } = ReactDom.findDOMNode(trigger).getBoundingClientRect()
      const {
        width: tooltipWidth,
        height: tooltipHeight
      } = ReactDom.findDOMNode(
        this._references.content.current
      ).getBoundingClientRect()

      if (position === 'left' || position === 'right') {
        let offsetTop = (triggerHeight - tooltipHeight) / 2
        if (offsetTop < 0 && offsetTop * -1 > triggerTop) {
          offsetTop = 0
          this._references.tip.current.style.top = `${triggerHeight / 2}px`
        } else {
          this._references.tip.current.style.top = '50%'
        }

        this._references.content.current.style.top = `${offsetTop}px`
      } else if (position === 'top' || position === 'bottom') {
        const offsetLeft = (triggerWidth - tooltipWidth) / 2
        this._references.content.current.style.left = `${offsetLeft}px`
      }
    }
  }

  render () {
    const { position, message, children } = this.props
    const { displayTooltip } = this.state

    return (
      <span className={`ctooltip${displayTooltip ? ' active' : ''}`}>
        <div
          className={`ctooltip-bubble ctooltip-${position}`}
          ref={this._references.content}
        >
          <div className='ctooltip-message'>
            {message && <IntlMessage ident={message} />}
            {children}
          </div>
          <span className='ctooltip-tip' ref={this._references.tip} />
        </div>
      </span>
    )
  }
}

export default Tooltip
